import Vue from 'vue';

export default {

	SET_CROPPA: function(state, payload) {
    	if(this.getters.devmode) console.debug('M|SET_CROPPA', payload);
    	state.croppa = payload;
    },
	UNSET_CROPPA: function(state) {
    	if(this.getters.devmode) console.debug('M|UNSET_CROPPA', payload);
    	state.croppa = false;
    },

	SET_MEDIA_STORE: function(state, payload) {
    	if(this.getters.devmode) console.debug('M|SET_MEDIA_STORE', payload);
    	state.media_store = payload;
    },
	UNSET_MEDIA_STORE: function(state) {
    	if(this.getters.devmode) console.debug('M|UNSET_MEDIA_STORE', payload);
    	state.media_store = false;
    },

	SET_LIVEPREVIEW: function(state, payload) {
    	if(this.getters.devmode) console.debug('M|SET_LIVEPREVIEW', payload);
    	state.livepreview = payload;
    },
	UNSET_LIVEPREVIEW: function(state) {
    	if(this.getters.devmode) console.debug('M|UNSET_LIVEPREVIEW', payload);
    	state.livepreview = false;
    },

	SET_INLINEMOD: function(state, payload) {
    	if(this.getters.devmode) console.debug('M|SET_INLINEMOD', payload);
    	state.inlinemod = payload;
    },
	UNSET_INLINEMOD: function(state) {
    	if(this.getters.devmode) console.debug('M|UNSET_INLINEMOD', payload);
    	state.inlinemod = false;
    },

    SET_AUTO_HIDE_NOTIFICATIONS: function(state, payload) {
    	if(this.getters.devmode) console.debug('M|SET_INLINEMOD', payload);
    	state.auto_hide_notifications = payload;
    },
	UNSET_AUTO_HIDE_NOTIFICATIONS: function(state) {
    	if(this.getters.devmode) console.debug('M|UNSET_INLINEMOD', payload);
    	state.auto_hide_notifications = false;
    },
}



// WEBPACK FOOTER //
// ./src/store/features/mutations.js